import React from "react";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Button from "@mui/material/Button";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import CheckIcon from "@mui/icons-material/Check";

export const Preview = (props = {}) => {
  const { showOptions = true } = props;

  return (
    <Box>
      {showOptions && (
        <Grid
          container
          justifyContent="flex-center"
          alignItems="center"
          spacing={2}
          sx={{
            zIndex: 1,
            position: "relative",
            top: "-20px",
          }}
        >
          <Grid item md={6} sm={6} xs={6}>
            <Button
              onClick={props.onDismiss}
              variant="contained"
              sx={{
                width: "100%",
                backgroundColor: "red",
                borderRadius: 0,
                height: "50px",
                "&:hover": {
                  backgroundColor: "red",
                },
              }}
              endIcon={<DeleteForeverIcon />}
            >
              {props.labels.dismiss}
            </Button>
          </Grid>

          <Grid item md={6} sm={6} xs={6}>
            <Button
              onClick={props.onConfirm}
              variant="contained"
              sx={{
                width: "100%",
                backgroundColor: "green",
                borderRadius: 0,
                height: "50px",
                "&:hover": {
                  backgroundColor: "green",
                },
              }}
              endIcon={<CheckIcon />}
            >
              {props.labels.confirm}
            </Button>
          </Grid>
        </Grid>
      )}
      <img
        alt="preview"
        width="100%"
        height="500"
        src={props.url}
        style={{ objectFit: "contain" }}
      />
    </Box>
  );
};
